import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'sag-ui-chip',
  template: `<span
    [class]="class"
    [style]="style"
    [selected]="selected"
    (click)="click.emit($event)"
    (blur)="blur.emit($event)"
    (focus)="focus.emit($event)"
    sag-ui-chip
  >
    <ng-content></ng-content>
    <span
      class="icon-close"
      tabindex="0"
      *ngIf="removable"
      (click)="remove.emit($event)"
      (keydown.enter)="$event.preventDefault(); remove.emit($event)"
      (keydown.space)="$event.preventDefault(); remove.emit($event)"
    ></span>
  </span>`,
})
export class ChipComponent {
  @Input() selected = false;
  @Input() removable = false;
  @Input() style = '';
  @Input() class = '';

  @Output() click: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
  @Output() blur: EventEmitter<FocusEvent> = new EventEmitter<FocusEvent>();
  @Output() focus: EventEmitter<FocusEvent> = new EventEmitter<FocusEvent>();
  @Output() remove: EventEmitter<Event> = new EventEmitter<Event>();
}
